module.exports = require("dagre-d3");